import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-talle',
  templateUrl: './talle.component.html',
  styleUrls: ['./talle.component.scss']
})
export class TalleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/talle/talle.component.ts